import { type FormElement } from '../components/form-elements/form-element';

const inputs: FormElement[] = [
  {
    key: 'name',
    type: 'text',
    label: 'Project Name',
    value: '',
    required: true,
    error: undefined,
    // validations
  },
  {
    key: 'status',
    type: 'select',
    label: 'Project Status',
    value: 'active',
    options: [
      {
        label: 'Active',
        value: 'active',
      },
      {
        label: 'On-hold',
        value: 'on-hold',
      },
      {
        label: 'Complete',
        value: 'complete',
      },
    ],
    required: false,
    error: undefined,
  },
  {
    key: 'customer',
    type: 'text',
    label: 'Customer',
    value: '',
    required: false,
    error: undefined,
  },
  {
    key: 'external_job_id',
    type: 'text',
    label: 'Job ID',
    value: '',
    required: false,
    error: undefined,
  },
  {
    key: 'start_date',
    type: 'date',
    label: 'Start Date',
    value: '',
    required: false,
    error: undefined,
  },
  {
    key: 'end_date',
    type: 'date',
    label: 'End Date',
    value: '',
    required: false,
    error: undefined,
  },
  {
    key: 'description',
    type: 'textarea',
    label: 'Description',
    value: '',
    required: false,
    error: undefined,
  },
  {
    key: 'project_manager_id',
    type: 'select',
    label: 'Project Manager',
    value: '',
    required: false,
    options: [],
    error: undefined,
  },
];

export default inputs;
